/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCode: {
  name: 'code';
  data: string;
} = {
  name: 'code',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.35 3.064a1 1 0 0 1 .586 1.287l-6 16a1 1 0 0 1-1.873-.702l6-16a1 1 0 0 1 1.288-.585ZM6.515 6.143a1 1 0 0 1 .343 1.372L4.166 12l2.691 4.485a1 1 0 1 1-1.715 1.03l-2.691-4.486a2 2 0 0 1 0-2.058l2.691-4.485a1 1 0 0 1 1.372-.343Zm12.343.343a1 1 0 0 0-1.715 1.029L19.834 12l-2.692 4.485a1 1 0 0 0 1.715 1.03l2.692-4.486a2 2 0 0 0 0-2.058l-2.692-4.485Z" fill="currentColor"/></svg>`,
};
